import { ColumnIcons, RefreshIcon } from "@assets/icons";
import { Button } from "@components/ui/button";
import DNDCOMP from "@pages/test";
import { endpoint } from "@services/api.services";
import { useQueryClient } from "@tanstack/react-query";
import FilterDropdown from "@ui/external/components/dropdown";
import { TableCard } from "@ui/internal/components/card";
import { exportToExcel, formatDate } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { ColumnType, QueryData } from "@utils/interface/index.interface";
import { EnrollmentData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore, useSelectionStore } from "@utils/states/index.state";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import EnrollmentForm, {
  ContactUsViewForm,
  EnrollmentViewForm,
  MasterClassEnrollViewForm,
  SessionInquiryForm,
  StudentConversionForm,
} from "./form/enrollment.form";

import { cn } from "@/lib/utils";
import Dialog from "@ui/external/components/dialog";
import FilterPopover from "@ui/internal/components/filter-popover";
import {
  Dialog as DialogEx,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  DialogPortal,
  DialogOverlay,
} from "@radix-ui/react-dialog";
import { DialogFooter, DialogHeader } from "@components/ui/dialog";

type ResponsesParams = {
  type:
    | "enrollment"
    | "request-form"
    | "contact-form"
    | "masterclass-enrollment"
    | "session-inquiry"
    | "giveaway"
    | "festival";
};

const index = () => {
  const { type } = useParams<ResponsesParams>();

  const pathname = usePathname();
  const queryClient = useQueryClient();
  const [openExcel, setOpenExcel] = useState(false);

  const endpointValue =
    type === "enrollment" || type === "masterclass-enrollment"
      ? endpoint["enrollment"]
      : type === "request-form"
        ? endpoint["request-form"]
        : type === "contact-form"
          ? endpoint["contactus"]
          : type === "session-inquiry"
            ? endpoint["email-sent"]
            : type === "giveaway"
              ? endpoint["enrollment"]
              : type === "festival"
                ? endpoint["enrollment"]
                : "";

  const toggleStudentConversion = () => setOpenModal((prev) => !prev);
  const allColumns = ColumnList();
  const [columns, setColumns] = useState<
    (ColumnType<EnrollmentData> & { id: number; checked: boolean })[]
  >([]);

  useEffect(() => {
    const newColumns =
      type === "contact-form"
        ? [
            allColumns[0],
            allColumns[12],
            ...allColumns.slice(1, 6),
            allColumns[18],
            allColumns[11],

            allColumns[16],
          ].map((item, index) => ({
            ...item,
            id: index + 1,
            checked: true,
          }))
        : type === "request-form"
          ? [
              allColumns[0],

              allColumns[12],
              allColumns[6],
              ...allColumns.slice(2, 5),
              allColumns[16],
            ].map((item, index) => {
              return {
                ...item,
                id: index + 1,
                checked: true,
              };
            })
          : type === "masterclass-enrollment"
            ? [
                allColumns[0],
                allColumns[12],
                ...allColumns.slice(1, 7),
                allColumns[21],
                allColumns[16],
                allColumns[17],
              ].map((item, index) => {
                return {
                  ...item,
                  id: index + 1,
                  checked: true,
                };
              })
            : type === "session-inquiry"
              ? [
                  allColumns[0],
                  allColumns[12],
                  ...allColumns.slice(1, 4),
                  allColumns[19],
                  allColumns[6],
                  allColumns[16],
                ].map((item, index) => {
                  return { ...item, id: index + 1, checked: true };
                })
              : type === "giveaway"
                ? [
                    allColumns[0],
                    allColumns[12],
                    ...allColumns.slice(1, 7),
                    ...allColumns.slice(13, 18),
                  ].map((item, index) => {
                    // console.log("THIS IS THE COLUMN 13", allColumns[13]);
                    return { ...item, id: index + 1, checked: true };
                  })
                : type === "festival"
                  ? [
                      allColumns[0],
                      allColumns[12],
                      allColumns[20],
                      ...allColumns.slice(1, 7),
                      allColumns[17],
                      allColumns[16],
                    ].map((item, index) => {
                      // console.log("THIS IS THE COLUMN 13", allColumns[13]);
                      return { ...item, id: index + 1, checked: true };
                    })
                  : [
                      allColumns[1],
                      allColumns[12],
                      ...allColumns.slice(2, 9),
                      allColumns[13],
                      allColumns[16],
                      allColumns[17],
                    ].map((item, index) => ({
                      ...item,
                      id: index + 1,
                      checked: true,
                    }));

    setColumns(newColumns);
  }, [type]);

  /* ================================================= column rearange logic ================================================= */
  const [searchParams, setSearchParams] = useSearchParams();
  const [_, setIsDraggable] = useState<boolean>(false);
  useEffect(() => {
    if (["drag"].includes(searchParams.get("orientation") || ""))
      return setIsDraggable(true);
    else return setIsDraggable(false);
  }, [searchParams.get("orientation")]);
  /* ================================================= api calls logic ================================================= */
  const { selectedRowDetails } = useSelectionStore();
  const [openModal, setOpenModal] = useState(false);
  const [shouldExport, setShouldExport] = useState(false);
  const [exportNumber, setExportNumber] = useState(10);
  const [loadRows, setLoadRows] = useState(10);

  const { search, date } = useMetaStore();
  const { data, refetch, isPending, isFetching, error } = useListData<
    QueryData<EnrollmentData>
  >({
    endpoint: endpointValue,
    key: `${pathname}-listing`,
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || loadRows,
      search,
      created_date__gte: date.from ? formatDate(date.from) : "",
      created_date__lte: date.to ? formatDate(date.to) : "",
      ordering: searchParams.get("ordering") || "-updated_date",
      course__id__in: searchParams.get("course") || "",
      learning_format: searchParams.get("learning_format") || "",
      has_laptop: searchParams.get("has_laptop") || "",
      category: searchParams.get("category") || "",
      is_masterclass:
        type === "masterclass-enrollment"
          ? true
          : type == "enrollment"
            ? false
            : "",
      is_festival: type == "festival",
      is_giveaway: type == "giveaway" ? true : false,
      subjects__id__in: searchParams.get("subjects") || "",
      festival: searchParams.get("festival") || "",
    },
  });

  useEffect(() => {
    if (shouldExport && data?.data?.results && !isFetching) {
      exportToExcel(data.data.results, `${type}.xlsx`);
      setShouldExport(false);
      setOpenExcel(false); // Close dialog after export
    }
  }, [data, isFetching, shouldExport]);

  // rollback page
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  return (
    <>
      <TableCard
        isOrientation={false}
        bulkActions
        table_content={{
          mode: "default",
          type: type || "",
        }}
        sortableFilter={{
          search,
          created_date__gte: date.from ? formatDate(date.from) : "",
          created_date__lte: date.to ? formatDate(date.to) : "",
          ordering: searchParams.get("ordering") || "-updated_date",
          course__id__in: searchParams.get("course") || "",
          learning_format: searchParams.get("learning_format") || "",
          has_laptop: searchParams.get("has_laptop") || "",
          is_student: false,
          subjects__id__in: searchParams.get("subjects__name") || "",
          is_masterclass: searchParams.get("is_masterclass") || "",
          is_enterprise: searchParams.get("is_enterprise") || "",
          category: searchParams.get("category") || "",
        }}
        tableHeaderData={
          <h2 className="capitalize w-full flex justify-between items-center">
            Showing all datas for {type?.replace("-", " ")}
            <span className="flex gap-3 items-center">
              <FilterDropdown
                className={"max-w-[250px]"}
                title={
                  <>
                    <ColumnIcons /> Column
                  </>
                }
              >
                <div>
                  <DNDCOMP
                    items={columns.filter((item) => item.name !== "ID")}
                    setItems={setColumns}
                  />
                </div>
              </FilterDropdown>
              <Button
                variant="outline"
                type="button"
                className={cn([isFetching ? "!cursor-progress" : ""])}
                onClick={() =>
                  queryClient.invalidateQueries({
                    queryKey: [`${pathname}-listing`],
                  })
                }
                disabled={isFetching}
              >
                <RefreshIcon className={isFetching ? "animate-spin" : ""} />
              </Button>
            </span>
          </h2>
        }
        inject_ui_table_actions={
          <>
            {data && data?.data?.results?.length > 0 && (
              // <Button
              //   type="button"
              //   onClick={() =>
              //     exportToExcel(data?.data?.results ?? [], `${type}.xlsx`)
              //   }
              //   variant={"outline"}
              // >
              //   Export .xlsx
              // </Button>
              <>
                <Button
                  type="button"
                  onClick={() => setOpenExcel(true)}
                  variant="outline"
                >
                  Export .xlsx
                </Button>
              </>
            )}
            {["enrollment"].includes(type as string) && (
              <FilterPopover
                title="Filter"
                filters={[
                  {
                    label: "Course",
                    endpointValue: "course",
                    format: { key: "title", value: "id" },
                  },
                  {
                    label: "Learning Format",
                    searchKey: "learning_format",
                    radio: true,
                    defaultOptions: [
                      { label: "Online", value: "online" },
                      { label: "Physical", value: "physical" },
                      { label: "Hybrid", value: "hybrid" },
                    ],
                  },
                  {
                    label: "Laptop",
                    searchKey: "has_laptop",
                    radio: true,
                    defaultOptions: [
                      { label: "Yes", value: "true" },
                      { label: "No", value: "false" },
                    ],
                  },
                ]}
              />
            )}
            {["masterclass-enrollment"].includes(type as string) && (
              <FilterPopover
                title="Filter"
                filters={[
                  {
                    label: "Course",
                    endpointValue: "course",
                    format: { key: "title", value: "id" },
                  },
                ]}
              />
            )}
            {["festival"].includes(type as string) && (
              <FilterPopover
                title="Filter"
                filters={[
                  {
                    label: "Festival",
                    endpointValue: "festival",
                    format: { key: "name", value: "id" },
                  },
                ]}
              />
            )}
            {["contact-form"].includes(type as string) && (
              <FilterPopover
                title="Filter"
                filters={[
                  {
                    label: "Subject",
                    endpointValue: "subjects",
                    format: {
                      key: "name",
                      value: "id",
                    },
                  },
                  {
                    label: "Categories",
                    searchKey: "category",
                    radio: true,
                    defaultOptions: [
                      {
                        label: "Masterclass",
                        value: "masterclass",
                      },
                      {
                        label: "Enterprise",
                        value: "enterprise",
                      },
                      {
                        label: "Skillshikshya",
                        value: "skillshikshya",
                      },
                    ],
                  },
                  // {
                  //   label: "Is Masterclass",
                  //   searchKey: "is_masterclass",
                  //   radio: true,
                  //   defaultOptions: [
                  //     {
                  //       value: "true",
                  //       label: "true",
                  //     },
                  //     {
                  //       value: "false",
                  //       label: "false",
                  //     },
                  //   ],
                  // },
                  // {
                  //   label: "Is Enterprise",
                  //   searchKey: "is_enterprise",
                  //   radio: true,
                  //   defaultOptions: [
                  //     {
                  //       value: "true",
                  //       label: "true",
                  //     },
                  //     {
                  //       value: "false",
                  //       label: "false",
                  //     },
                  //   ],
                  // },
                ]}
                key={type}
                triggerText="Filter"
              />
            )}
            {selectedRowDetails.length > 0 && (
              <Button onClick={() => setOpenModal((prev) => !prev)}>
                Convert To Student
              </Button>
            )}
          </>
        }
        isPending={isPending}
        columns={columns}
        endpoint={endpointValue}
        refetch={refetch}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={
          type == "contact-form" ? (
            <ContactUsViewForm />
          ) : (type == "enrollment" || type == "masterclass-enrollment") &&
            searchParams.get("drawer-item") ? (
            type == "enrollment" ? (
              <EnrollmentViewForm />
            ) : (
              <MasterClassEnrollViewForm />
            )
          ) : type == "session-inquiry" ? (
            <SessionInquiryForm refetch={refetch} />
          ) : (
            <EnrollmentForm refetch={refetch} />
          )
        }
      />
      <Dialog
        className={cn([
          "bg-white shadow-none border-none",
          "min-w-[1000px] max-lg:min-w-full max-md:max-h-[400px] max-h-[500px]",
        ])}
        open={openModal}
        setOpen={setOpenModal}
      >
        <div className="w-full max-md:max-h-[300px] max-h-[400px] overflow-y-auto ">
          <div className="w-full h-full">
            <StudentConversionForm
              refetch={refetch}
              toggleStudentConversion={toggleStudentConversion}
              studentData={selectedRowDetails}
            />
          </div>
        </div>
      </Dialog>

      <DialogEx open={openExcel} onOpenChange={setOpenExcel}>
        <DialogPortal>
          <DialogOverlay className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
          <DialogContent className="fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg">
            <div>
              <DialogTitle className="text-lg font-semibold">
                Confirm Export
              </DialogTitle>
            </div>
            <div className="flex gap-2">
              <label>Enter Number of Rows:</label>
              <input
                type="number"
                className="border border-black rounded-sm px-2 py-1"
                placeholder="Enter number"
                onChange={(e) => setExportNumber(Number(e.target.value))}
              />
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setOpenExcel(false)}>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setLoadRows(exportNumber);
                  setShouldExport(true);
                }}
              >
                Export
              </Button>
            </div>
          </DialogContent>
        </DialogPortal>
      </DialogEx>
    </>
  );
};

export default index;
